import { Text, VStack } from '@ayble-health/dashboard-components';
import styled from '@emotion/styled';
import type { EmotionTheme } from '../../theme/emotionTheme';

const Link = styled('a')<{ theme?: EmotionTheme }>`
  color: white;
  text-decoration: underline;
  transition: color linear 200ms;

  &:hover {
    color: ${(p) => p.theme.colors.primary['600']};
    cursor: pointer;
  }
`;

export const Footer = () => {

  return (
    <VStack
      alignItems={'start'}
      bgColor={'secondary.500'}
      p={{ base: 8, md: 12 }}
    >

      <Text
        color={'white'}
        fontSize={{ base: 'lg', md: 'xl' }}
        fontWeight={'medium'}
        pt={12}
      >
        Any questions? Email:{' '}
        <Link href="mailto:support@ayblehealth.com">
          support@ayblehealth.com
        </Link>
      </Text>
    </VStack>
  );
};
